
import { mapState } from 'vuex'
import { printer, downloadFile, decodeBase64 } from '@/utils/utils'
export default {
  model: {
    prop: 'modalValue',
    event: 'updateModalValue',
  },
  props: {
    modalValue: {
      type: Boolean,
      default: false,
    },
    certList: {
      type: Object,
      default: () => {},
    },
    showReceiptProof: {
      type: Boolean,
      default: false,
    },
    showDeliveryCert: {
      type: Boolean,
      default: false,
    },
    showSignReceipt: {
      type: Boolean,
      default: false,
    },
    showSignedDo: {
      type: Boolean,
      default: false,
    },
    showPostAssembly: {
      type: Boolean,
      default: false,
    },
    destCountryCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      signImgType: '252',
      activeKey: '2',
      current1: 1,
      current2: 1,
      imgObj1: {},
      imgArr: [],
      imgArr3: [],
      imgArr4: [],
      carouselProps: {
        autoplay: false,
        arrows: true,
      },

      imgObj1List: [],
      butDisabled: false,
      timer: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.modalValue
      },
      set(value) {
        this.$emit('updateModalValue', value)
      },
    },
    hideDeliveryCert() {
      return this.destCountryCode.toLowerCase() === 'sg'
    },
    // 所有 CMS 规则均未命中：无权限查看
    noPermission() {
      return (
        !this.showReceiptProof &&
        !this.showDeliveryCert &&
        !this.showSignReceipt &&
        !this.showSignedDO &&
        !this.showPostAssembly
      )
    },
    // 当前可见 Tab 数量是否为 1（等同于旧 GE+ 单 tab 场景，隐藏下划线）
    isSingleTab() {
      const count = [
        this.showReceiptProof,
        this.showDeliveryCert,
        this.showSignReceipt,
        this.showSignedDo,
        this.showPostAssembly,
      ].filter(Boolean).length
      return count === 1
    },
  },
  watch: {
    visible(n) {
      n &&
        this.$nextTick(() => {
          this.changeTab()
        })
    },
    certList: {
      handler(n) {
        if (n) {
          this.initData(n)
        }
      },
      deep: true,
    },
  },
  mounted() {
    // 按可见性设置默认 Tab，initData 中 selectFirstAvailableTab 会根据数据再精调
    if (this.showReceiptProof) {
      this.activeKey = '1'
    } else if (this.showDeliveryCert) {
      this.activeKey = '2'
    } else if (this.showSignReceipt) {
      this.activeKey = '5'
    } else if (this.showSignedDo) {
      this.activeKey = '3'
    } else if (this.showPostAssembly) {
      this.activeKey = '4'
    }
  },
  beforeDestroy() {
    if(this.timer){
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    changeTab() {    
      // 清理之前的定时器
      if (this.timer) {
        clearTimeout(this.timer)
      }
      let that = this
      this.timer = setTimeout(() => {
        const dom = document
          .querySelector('.cert-content')
          .querySelector('.ant-tabs-tab-active')
        if (!dom) {
          return
        }
        const bar = document
          .querySelector('.cert-content')
          .querySelector('.ant-tabs-ink-bar')
        bar.style.marginLeft = dom.offsetWidth / 4 + 'px'
        bar.style.width = dom.offsetWidth / 2 + 'px'

        // 根据当前 tab 和数据判断按钮是否禁用
        if (that.activeKey === '1' && !that.imgObj1?.imageData) {
          that.butDisabled = true
        } else if (that.activeKey === '2' && !that.imgArr.length) {
          that.butDisabled = true
        } else if (that.activeKey === '5' && !that.imgObj1List.length) {
          that.butDisabled = true
        } else if (that.activeKey === '3' && !that.imgArr3.length) {
          that.butDisabled = true
        } else if (that.activeKey === '4' && !that.imgArr4.length) {
          that.butDisabled = true
        } else {
          that.butDisabled = false
        }
      }, 1000)
    },
    rotate() {
      const currentKey = `current${this.activeKey}`;
      const refKey = `image${this.activeKey}`;
      if (this[currentKey] === 4) {
        this[currentKey] = 0
      }
      const imageRef = this.$refs[refKey];
      if (imageRef) {
        imageRef.style = `transform: rotate(${
          this[currentKey] * 90
        }deg);`
        this[currentKey]++
      }
    },
    rotateTif() {
      const currentKey = `current${this.activeKey}`;
      if (this[currentKey] === 4) {
        this[currentKey] = 0
      }
      const tifRef = this.$refs.tif;
      if (tifRef) {
        tifRef.style = `transform: rotate(${
          this[currentKey] * 90
        }deg);`
        this[currentKey]++
      }
    },
    initData(list) {
      // 确保 list 是一个对象
      if (!list || typeof list !== 'object') {
        list = {}
      }

      // Tab 1 签收证明：imageType 252
      const receiptImages = list['252'] || []
      const imageList = [
        ...(list['2'] || []),
        ...(list['5'] || []),
        ...(list['15'] || []),
        ...(list[this.signImgType] || [])
      ]
      imageList.sort((a,b) => b.imageType - a.imageType)
      if (receiptImages.length > 0) {
        this.imgObj1 = receiptImages[0]
      } else {
        this.imgObj1 = {}
      }

      // Tab 5 签收底单：imageType 2, 5
      let array = [
        ...(list['2'] || []),
        ...(list['5'] || []),
      ]
      array.sort((a, b) => b.imageType - a.imageType)
      this.imgObj1List = array

      // Tab 2 派送证明：imageType 15
      this.imgArr = list['15'] ?? []
      // Tab 3 签单返还：imageType 71
      this.imgArr3 = list['71'] ?? []
      // Tab 4 宅配延伸：imageType 68
      this.imgArr4 = list['68'] ?? []

      // 数据就绪后，自动选择第一个有数据的 Tab
      this.$nextTick(() => {
        this.selectFirstAvailableTab()
      })
    },
    // 按 Tab 顺序（1→2→5→3→4）选择第一个有数据的 Tab
    // 当所有 Tab 都无数据时，回退到第一个可见 Tab，保证弹框不会空白
    selectFirstAvailableTab() {
      const candidates = []

      if (this.showReceiptProof) {
        candidates.push({ key: '1', hasData: !!this.imgObj1?.imageData })
      }
      if (this.showDeliveryCert) {
        candidates.push({ key: '2', hasData: this.imgArr.length > 0 })
      }
      if (this.showSignReceipt) {
        candidates.push({ key: '5', hasData: this.imgObj1List.length > 0 })
      }
      if (this.showSignedDo) {
        candidates.push({ key: '3', hasData: this.imgArr3.length > 0 })
      }
      if (this.showPostAssembly) {
        candidates.push({ key: '4', hasData: this.imgArr4.length > 0 })
      }

      if (candidates.length === 0) return

      // 优先选第一个有数据的 Tab，否则回退到第一个可见 Tab
      const firstWithData = candidates.find(c => c.hasData)
      this.activeKey = (firstWithData || candidates[0]).key
    },
    isTif(type) {
      return type?.toUpperCase() === 'TIF'
    },

    download() {
      // Tab 1 签收证明：直接下载单张图片
      if (this.activeKey === '1') {
        const aLink = document.createElement('a')
        aLink.href = this.imgObj1.imageData
        aLink.click()
        window.URL.revokeObjectURL(aLink.href)
        return
      }
      // 其他 Tab：通过轮播组件下载
      if (this.activeKey === '5') {
        const index = this.$refs.carouselRef5.getCurrentIndex()
        const item = this.imgObj1List[index]
        downloadFile(`${item.waybillNo}-${index}`, item.imageData)
      } else if (this.activeKey === '3') {
        const index = this.$refs.carouselRef3.getCurrentIndex()
        const item = this.imgArr3[index]
        downloadFile(`${item.waybillNo}-${index}`, item.imageData)
      } else if (this.activeKey === '4') {
        const index = this.$refs.carouselRef4.getCurrentIndex()
        const item = this.imgArr4[index]
        downloadFile(`${item.waybillNo}-${index}`, item.imageData)
      } else if (this.activeKey === '2') {
        const index = this.$refs.carouselRef2.getCurrentIndex()
        const item = this.imgArr[index]
        downloadFile(`${item.waybillNo}-${index}`, item.imageData)
      }
    },
    printer() {
      if (this.activeKey === '1') {
        // 签收证明
        printer(this.$refs[`img${this.activeKey}`])
      } else if (this.activeKey === '5') {
        // 签收底单
        const index = this.$refs.carouselRef5.getCurrentIndex()
        const ref = this.$refs.carouselRef5?.$refs['imgRef' + index]
        const length = ref.length
        printer(ref[length - 1])
      } else if (this.activeKey === '2') {
        // 派送证明
        const index = this.$refs.carouselRef2.getCurrentIndex()
        const ref = this.$refs.carouselRef2?.$refs['imgRef' + index]
        const length = ref.length
        printer(ref[length - 1])
      } else if (this.activeKey === '3') {
        const index = this.$refs.carouselRef3.getCurrentIndex()
        const ref = this.$refs.carouselRef3?.$refs['imgRef' + index]
        const length = ref.length
        printer(ref[length - 1])
      } else if (this.activeKey === '4') {
        const index = this.$refs.carouselRef4.getCurrentIndex()
        const ref = this.$refs.carouselRef4?.$refs['imgRef' + index]
        const length = ref.length
        printer(ref[length - 1])
      }
    },
    handlerTiff(image) {
      if (this.isTif(image.fileType)) {
        try {
          const imageDataParts = image.imageData.split(',');
          if (imageDataParts.length < 2) {
            console.warn('Invalid base64 format in image data');
            return;
          }
          const base64 = imageDataParts[1]
          const buffer = decodeBase64(base64)
          const tiff = new window.Tiff({ buffer })
          if (tiff._tiffPtr !== 0) {
            const canvas = tiff.toCanvas()
            this.$nextTick(() => {
              const canvasItem = this.$refs.tif
              if (!canvasItem) {
                console.warn('Canvas reference not found');
                return;
              }
              canvas.setAttribute(
                'style',
                `width: ${canvasItem.offsetWidth}px;height: ${canvasItem.offsetHeight}px;`
              )
              canvasItem.appendChild(canvas)
            })
          } else {
            console.warn('Invalid TIFF object or failed to load TIFF');
          }
        }catch (error) {
          console.error('Error processing TIFF image:', error);
        }
      }
    },
  },
}
